var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13497 0V2.95428H3.06357V6.87747H0V0H7.13497Z",
    fill: "#C75227"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3074 19.4016V26.2791H14.1755V23.3248H18.2439V19.4016H21.3074Z",
    fill: "#C75227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46065 3.9675H4.39233V7.89366H8.46065V3.9675Z",
    fill: "#C75227"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38977 7.89175H1.37329V25.1777H12.8476V22.2678H4.38977V7.89175Z",
    fill: "#C75227"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9195 18.343H19.9374V1.05862H8.46167V3.96804H16.9195V18.343Z",
    fill: "#C75227"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3074,
    height: 26.2791,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameit);
export default __webpack_public_path__ + "static/media/frameit.e844fa2d65dc22c521b3a42ff7401cfa.svg";
export { ForwardRef as ReactComponent };